export default __webpack_public_path__ + "static/media/background_service_card_1.750b9c77.png";